var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fixed-img"},[_c('i',{staticClass:"iconfont icon-guanbi",on:{"click":_vm.close}}),_c('div',{staticClass:"fixed-img-box"},[_c('img',{staticClass:"share-img",attrs:{"src":_vm.url}}),_c('p',[_vm._v("长按图片保存到手机分享客户")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }